import {computed, reactive, ref} from "vue";
import {AsyncState} from "@/enums";
import OrderOperatorService, {OrderOperatorV3Dto} from "@/service/OrderOperatorService";
import {OrderOperator} from "@/views/Orders/Operators/OrderOperators.vue";

export function init() {

  const initialState = {
    asyncState: null as unknown as AsyncState,
  };

  const state = reactive({...initialState});
  const $externalResults = ref({});

  const isLoading = computed(() => {
    return state.asyncState == AsyncState.LOADING;
  });

  const isError = computed(() => {
    return state.asyncState == AsyncState.ERROR;
  });

  const isSuccess = computed(() => {
    return state.asyncState == AsyncState.SUCCESS;
  });

  // Writes the changes into the row before sending it, so that a change sent while another one of the same row is
  // still in flight carries both. The v3 endpoints replace the whole operator, so the request always sends every field.
  const createOrUpdate = (orderUuid: string, item: OrderOperator, changes: Partial<OrderOperator>): Promise<OrderOperatorV3Dto> => {
    const previous = {...item};
    Object.assign(item, changes);

    const data = {
      operatorNumber: item.operatorNumber,
      numberOfPositions: item.numberOfPositions,
      qualityLevel: item.qualityLevel,
      valueOfGoods: item.valueOfGoods
    };

    state.asyncState = AsyncState.LOADING;
    const request = item.id
      ? OrderOperatorService.updateOrderOperatorV3(orderUuid, item.id, data)
      : OrderOperatorService.createOrderOperatorV3(orderUuid, {employeeId: item.employee.uuid, ...data});

    return request
      .then(response => {
        state.asyncState = AsyncState.SUCCESS;

        return Promise.resolve(response.data);
      })
      .catch(error => {
        state.asyncState = AsyncState.ERROR;

        // Undo the changes unless a later change of the same field has replaced them meanwhile
        (Object.keys(changes) as Array<keyof OrderOperator>).forEach(key => {
          if (item[key] === changes[key]) {
            // @ts-ignore
            item[key] = previous[key];
          }
        });

        return Promise.reject(error);
      });
  };

  return {
    state,
    $externalResults,
    createOrUpdate,
    isLoading,
    isError,
    isSuccess
  };
}
